export default __webpack_public_path__ + "static/media/elec.9910b541.svg";